import { Button, Col, Divider, Layout, Popconfirm, Progress, Row } from 'antd';
import React, { useState } from 'react';
import './App.css';
import 'antd/dist/antd.css';
import { Header, Content, Footer } from 'antd/lib/layout/layout';
import { useWindowDimensions } from './useWindowDimensions';
import { MinusCircleTwoTone, PlusCircleTwoTone } from '@ant-design/icons';
import produce from "immer";

interface IPlayer {
  name: string;
  score: number;
  startScore: number;
}

const initialState = [{ name: 'Marc', score: 10, startScore: 10 }, { name: 'Tobi', score: 10, startScore: 10 }, { name: 'Nikita', score: 10, startScore: 10 }, { name: 'Flo', score: 10, startScore: 10 }];

function App() {
  const [torwart, setTorwart] = useState<IPlayer | null>(null);
  const [players, setPlayers] = useState<IPlayer[]>(initialState);
  const { height, width } = useWindowDimensions();

  if (torwart === null) {
    return (
      <div className="App">
        <div style={{ display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <div style={{ fontSize: '10vw' }}>Wer ist Torwart?</div>
          <div>
            {players.map(t => {
              return (
                <div>
                <Button 
                  style={{ width: width / (players.length), height: height / (players.length + 2), fontSize: '8vw', marginLeft: '30px' }}
                  onClick={() => {
                    setPlayers([{...t, startScore: 11, score: 11}, ...players.filter(x => x.name !== t.name)])
                    setTorwart(t);
                  }}
                >{t.name}</Button>
                </div>
              );
            }
            )}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="App">
      <Layout>
        <Header>
          <Popconfirm 
            title="Spielstand wirklich zurücksetzen?" 
            onConfirm={() => {
              setPlayers(initialState);
              setTorwart(null);
            }}
          ><Button>Neues Spiel starten</Button></Popconfirm></Header>
        <Content>
          <Row style={{ height: '100%' }}>
            {players.map(t => {
              return (
                <Col span={6} key={t.name} style={{ height: '100%', display: 'grid', placeItems: 'center' }}>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ fontSize: '8vh', textAlign: 'center', marginBottom: '40px' }}>{t.name}</div>
                    <Progress width={width / (players.length + 2)}  type="circle" percent={t.score / t.startScore * 100} format={() => <div style={{ fontSize: '8vh' }}>{t.score}</div>} />
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: '40px' }}>
                      <PlusCircleTwoTone onClick={() => setPlayers(produce(players, draft => { draft.find(x => x.name === t.name)!.score++ }))} twoToneColor="green" style={{ fontSize: '15vh', cursor: 'pointer' }} />
                      <MinusCircleTwoTone onClick={() => setPlayers(produce(players, draft => { draft.find(x => x.name === t.name)!.score-- }))} twoToneColor="red" style={{ fontSize: '15vh', cursor: 'pointer', marginLeft: '40px' }} />
                    </div>
                  </div>
                </Col>
              );
            })}
          </Row>
        </Content>
        <Footer></Footer>
      </Layout>
      
    </div>
  );
}

export default App;
